var map = {
	"./accept-reject.svg": 1627,
	"./active-player.svg": 1628,
	"./add.svg": 1629,
	"./angle-down.svg": 1630,
	"./angle-left.svg": 1631,
	"./angle-right.svg": 1632,
	"./angle-up.svg": 1633,
	"./arrow-down.svg": 1634,
	"./arrow-left.svg": 1635,
	"./arrow-right.svg": 1636,
	"./arrow-up.svg": 1637,
	"./bell.svg": 1638,
	"./cake.svg": 1639,
	"./calendar.svg": 1640,
	"./cancel.svg": 1641,
	"./check.svg": 1642,
	"./close-popup.svg": 1643,
	"./connect.svg": 1644,
	"./cup.svg": 1645,
	"./delete.svg": 1646,
	"./dollar-in.svg": 1647,
	"./dollar-out.svg": 1648,
	"./dollar.svg": 1649,
	"./edit.svg": 1650,
	"./enlarge.svg": 1651,
	"./filter.svg": 1652,
	"./hamburger-menu.svg": 1653,
	"./heart-check.svg": 1654,
	"./inactive-player.svg": 1655,
	"./instat.svg": 1656,
	"./minus.svg": 1657,
	"./pause.svg": 1658,
	"./people-gallery.svg": 1659,
	"./people-join.svg": 1660,
	"./people.svg": 1661,
	"./pin.svg": 1662,
	"./play.svg": 1663,
	"./print.svg": 1664,
	"./report.svg": 1665,
	"./rpe.svg": 1666,
	"./save.svg": 1667,
	"./search.svg": 1668,
	"./thumb-down.svg": 1669,
	"./thumb-up.svg": 1670,
	"./time.svg": 1671,
	"./training.svg": 1672,
	"./trend-down.svg": 1673,
	"./trend-up.svg": 1674,
	"./view.svg": 1675,
	"./x-large.svg": 1676,
	"./x-small.svg": 1677,
	"./zoom-in.svg": 1678,
	"./zoom-out.svg": 1679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1009;